import { Platform } from 'react-native'

import { useQuery } from '@tanstack/react-query'
import { FIVE_MINUTES } from '@zet/utils/cacheTime'

import { useRecommendationFlow } from '../../../utils/hooks/useRecommendationFlow'
import { getLoyaltyPayout } from '../functions/getLoyaltyPayout'

type useLoyaltyPayoutProps = {
  partnerId?: number | string
  partnerCategoryId?: string | number
  isHighestLoyaltyPayout?: boolean
  isAllLevelPayout?: boolean
  isUserCurrentTierPayout?: boolean
}

export const useLoyaltyPayout = ({
  partnerId,
  partnerCategoryId,
  isHighestLoyaltyPayout,
  isAllLevelPayout,
  isUserCurrentTierPayout,
}: useLoyaltyPayoutProps) => {
  const { isNewRecommendationFlow } = useRecommendationFlow()

  return useQuery(
    [
      'loyaltyExtraPayout',
      {
        partnerId,
        partnerCategoryId,
        isHighestLoyaltyPayout,
        isAllLevelPayout,
        isUserCurrentTierPayout,
        isNewRecommendationFlow,
      },
    ],
    () =>
      getLoyaltyPayout({
        partnerId,
        partnerCategoryId,
        isHighestLoyaltyPayout,
        isAllLevelPayout,
        isUserCurrentTierPayout,
        isNewRecommendationFlow,
      }),
    {
      staleTime: FIVE_MINUTES,
      cacheTime: FIVE_MINUTES,
      enabled: Platform.OS !== 'web',
    }
  )
}
